import React from "react";
import { APP_VERSION } from "@/lib/version";

export default function Footer({ className = "" }) {
  return (
    <footer
      data-testid="app-footer"
      className={`flex flex-row flex-nowrap items-center justify-center gap-2 sm:gap-3 text-center text-[11px] sm:text-[12px] text-slate-500 py-4 whitespace-nowrap overflow-x-auto ${className}`}
    >
      <span className="whitespace-nowrap">
        © 2026{" "}
        <a
          href="https://iqdsgn.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="dr-link"
          data-testid="footer-brand"
        >
          IQdsgn.com
        </a>{" "}
        Tüm hakları saklıdır
      </span>
      <span className="text-slate-300">|</span>
      <span className="whitespace-nowrap">
        Altyapı &amp; Tasarım:{" "}
        <a
          href="https://www.dijitalroket.com"
          target="_blank"
          rel="noopener noreferrer"
          className="dr-link"
          data-testid="footer-dijitalroket-link"
        >
          Dijital Roket
        </a>
      </span>
      <span className="text-slate-300">·</span>
      <span
        className="tracking-wider uppercase text-[10.5px] text-slate-400 whitespace-nowrap"
        data-testid="footer-app-version"
      >
        v{APP_VERSION}
      </span>
    </footer>
  );
}
